import { useEffect } from 'react'
import useData from '../../../common/hooks/useData'
import SelectInput from './SelectInput'

export default function ResourceDropdownInput({
    id,
    url,
    value,
    onChange,
    getItems,
    getItemLabel,
    getItemValue,
    errors,
    ...rest
}) {
    const { items, itemsError, itemsLoading } = useData(
        url,
        'items',
        (data) => getItems(data) || [],
    )

    useEffect(
        function () {
            if (!items?.length && value) {
                onChange(undefined)
            }
        },
        [items?.length],
    )

    function handleChange(v) {
        onChange(v)
    }

    const inputValue = value || ''

    if (itemsLoading) {
        return (
            <SelectInput
                value={''}
                id={id}
                disabled
                options={[
                    {
                        value: '',
                        label: 'Loading...',
                    },
                ]}
            />
        )
    }

    if (itemsError) {
        return (
            <SelectInput
                required={rest.required}
                id={id}
                disabled
                options={[
                    {
                        value: '',
                        label: 'Error',
                    },
                ]}
                errors={[true]}
            />
        )
    }

    return (
        <SelectInput
            required={rest.required}
            disabled={rest.disabled}
            id={id}
            value={inputValue}
            onChange={handleChange}
            options={[
                {
                    value: '',
                    label: '',
                },
                ...items.map((item) => ({
                    value: getItemValue(item),
                    label: getItemLabel(item),
                })),
            ]}
            errors={errors}
        />
    )
}
